let labelType = 's0722460';
let ean = '8719538654648';
let name = 'Product naam';

function labelXml() {
	if (labelType === 's0722460') {
		// eslint-disable-next-line no-use-before-define
		return DymoS0722460();
	}
}

function DymoS0722460() {
	let DymoS0722460 = null;

	try {
		DymoS0722460 = dymo.label.framework.openLabelFile(process.env.VUE_APP_BASE_URL + 'dymo/labels/dls/ean/S0722460.xml');
	} catch (error) {
		DymoS0722460 = dymo.label.framework.openLabelFile(process.env.VUE_APP_BASE_URL + 'dymo/labels/dcd/ean/S0722460.xml');
	}

	return DymoS0722460;
}

function createLabel() {
	const label = labelXml();

	label.setObjectText('ean', ean);
	label.setObjectText('productname', name);

	return label;
}

export default {
	setEan(newEan) {
		ean = newEan;
	},
	setName(newName) {
		name = newName;
	},
	setLabelType(newLabelType) {
		labelType = newLabelType;
	},
	getLabel: createLabel,
}
